// extracted by mini-css-extract-plugin
module.exports = {"term":"Glossary_term__1sogC","glossaryBody":"Glossary_glossaryBody__1WtVZ"};